<div class="main_wrap">
    <div class="custom_header">
        <div class="img_wrap">
            <img src="./../../assets/images/login_logo.jpeg" alt="logo" />
        </div>
        <h2>Shree Mahakaleshwar Jyotirling, Ujjain</h2>

    </div>

    <div class="mobile_header">

    </div>

    <div class="card_wrap">
        <div class="sub_header_wrap">
            <h4>Bhasmaarti Dashboard</h4>
        </div>
        <div class="card" style="width: 100%;">
            <div *ngIf="drillLevel > 1">
                <button class="btn btn-primary" style="float: right;background-color: #f44336 !important;"
                    (click)="goBack()">← Back</button>
            </div>
            <div class="card-body upper-header" style="width: 100%;">
                <div style="width: 100%;overflow: auto;">
                    <div [ngClass]="{'chart_wrap': drillLevel > 2}" class="chart_wraper"
                        *ngIf="barChartData?.length && barChartLabels?.length">

                        <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels"
                            [options]="barChartOptions" [legend]="barChartLegend" [chartType]="barChartType"
                            [plugins]="barChartPlugins"
                            (chartClick)="onChartClick($event)">
                        </canvas>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>